export enum APPROVAL_STATUS {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
}

export const APPROVAL_STATUS_CHOICES = [
  { id: APPROVAL_STATUS.PENDING, name: 'Pending' },
  { id: APPROVAL_STATUS.APPROVED, name: 'Approved' },
  { id: APPROVAL_STATUS.REJECTED, name: 'Rejected' },
];

export enum BID_TYPE {
  CATEGORY = 1,
  PRODUCT = 2,
}

export const BID_TYPE_CHOICES = [
  { id: BID_TYPE.CATEGORY, name: 'Category Bid' },
  { id: BID_TYPE.PRODUCT, name: 'Product Bid' },
];
